import axios from "axios";
import store from "../../store/index";
import siteSummary from "../DataSIgnalSiteSummaryPopup/DataSIgnalSiteSummaryPopup.vue";
import criticalSignal from "../CriticalSignalPopup/CriticalSignalPopup.vue";
import SiteAffectedDetailsModal from "./SiteAffectedDetailsModal.vue";

export default {
  name: "DataSignalOverview",
  data() {
    return {
      head: {},
      idToken: "",
      baseUrl: process.env.VUE_APP_Service_URL,
      studyId: "",
      siteCount: 0,
      signalCount: 0,
      siteSummary: [],
      repatetionSummary: [],
      corelationSummary: [],
      repatitionCount: 0,
      correlationCount: 0,
      showSiteSummary: false,
      showCriticalSites: false,
      showCorerelationSites: false,
      showRepatetionSites: false,

      DataSignalSummaryForList: [],
      transformedTechniqueData: [],
      baseapi: process.env.VUE_APP_Service_URL,
      criticalSignalSeries: [],
      criticalSignalOptions: {},
      criticalSignalTrendSeries: [],
      criticalSignalTrendOptions: {},
      showSiteAffectedModal: false,
      showSiteNotAffectedModal: false,
      selectedTechniqueName: "",
      siteAffectedDetails: [],
      siteNotAffectedDetails: [],
      dataSignalSiteSummary: [],
      dataSignalGridData : [],

    };
  },
  components: {
    siteSummary,
    criticalSignal,
    SiteAffectedDetailsModal
  },
  async mounted() {
    this.idToken = store.getters.getIdToken;
    this.head = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    this.studyId = store.getters.getStudyIs;
    this.siteSummary = await this.getSiteSummary("");
    this.siteCount = this.siteSummary.length ? this.siteSummary.length : 0;
    this.signalCount = this.siteSummary.reduce(
      (total, site) => total + (site.criticalSignalsCount || 0),
      0
    );

    this.repatetionSummary = await this.getSiteSummary("RD");
    this.repatitionCount = this.repatetionSummary.length ? this.repatetionSummary.length : 0;
    this.correlationSummary = await this.getSiteSummary("CORR");
    this.correlationCount = this.correlationSummary.length ? this.correlationSummary.length : 0;

    this.getDataSignalStudySiteSummary();
    this.getCriticalDataSignalChart();
    this.getDataSignalGridData();
  },
  methods: {
    
    async getDataSignalStudySiteSummary() {
      const idtoken = store.getters.getIdToken;
      this.studyId = store.getters.getStudyIs;

      // optional loader flag
      this.dataSignalLoading = true;

      try {
        const url =
          this.baseapi +
          "/forms/rbqm/getdatasignalsummary?studyId=" +
          encodeURIComponent(this.studyId) + "&flagged=true&level=Site&isActive=true";

        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json"
          }
        });

        // API returns array directly
        const entities = Array.isArray(res.data) ? res.data : [];
        const rawEntities = entities;
        // store raw response (useful for drilldown)
        this.dataSignalSiteSummary = entities;
        this.DataSignalSummaryForList = entities;
        
        console.log("DataSignalSummaryForList", this.DataSignalSummaryForList);
        const categories = [];
        const values = [];

        for (let i = 0; i < entities.length; i++) {
          const it = entities[i];

          // safe siteCode extraction
          let siteCode = "";
          if (it && it.siteCode !== undefined && it.siteCode !== null) {
            siteCode = String(it.siteCode).trim();
          }

          if (!siteCode) continue;

          // safe number extraction
          let y = 0;
          if (it && it.criticalSignalsCount !== undefined && it.criticalSignalsCount !== null) {
            const num = Number(it.criticalSignalsCount);
            y = isFinite(num) ? num : 0;
          }

          categories.push(siteCode);
          values.push(y);
        }

        // Apex series
        this.criticalSignalSeries = [
          {
            name: "Critical Signals",
            data: values
          }
        ];
        console.log("criticalSignalSeries", this.criticalSignalSeries);
        // Apex options
        this.criticalSignalOptions = {
          chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false }
          },
          plotOptions: {
            bar: {
              columnWidth: "55%",
              borderRadius: 4
            }
          },
          dataLabels: {
            enabled: true
          },
          xaxis: {
            categories: categories,
            title: { text: "Site Code" },
            labels: {
              rotate: -45,
              trim: true
            }
          },
          yaxis: {
            title: { text: "Critical Signals Count" },
            min: 0
          },
         tooltip: {
  shared: false,
  intersect: true,
  custom: function ({ series, seriesIndex, dataPointIndex, w }) {
    // For bar chart x-axis labels, Apex uses categoryLabels most reliably
    var labels =
      (w && w.globals && w.globals.categoryLabels && w.globals.categoryLabels.length)
        ? w.globals.categoryLabels
        : (w && w.globals && w.globals.labels ? w.globals.labels : []);

    var siteCode = labels && labels[dataPointIndex] ? String(labels[dataPointIndex]).trim() : "";

    // value
    var count = 0;
    if (series && series[seriesIndex] && typeof series[seriesIndex][dataPointIndex] !== "undefined") {
      count = series[seriesIndex][dataPointIndex];
    }

    // find row by siteCode (case-insensitive + trim safe)
    var row = null;
    for (var i = 0; i < rawEntities.length; i++) {
      var sc = rawEntities[i] && rawEntities[i].siteCode ? String(rawEntities[i].siteCode).trim() : "";
      if (sc && sc.toLowerCase() === siteCode.toLowerCase()) {
        row = rawEntities[i];
        break;
      }
    }

    // collect field names
    var fieldNames = [];
    if (row && row.criticalDataSignal && row.criticalDataSignal.length) {
      for (var a = 0; a < row.criticalDataSignal.length; a++) {
        var sig = row.criticalDataSignal[a];
        var flagTypes = (sig && sig.flagTypes) ? sig.flagTypes : [];
        for (var b = 0; b < flagTypes.length; b++) {
          var ft = flagTypes[b];
          if (ft && Array.isArray(ft.fieldName)) {
            for (var c = 0; c < ft.fieldName.length; c++) {
              var f = String(ft.fieldName[c] || "").trim();
              if (f) fieldNames.push(f);
            }
          }
        }
      }
    }

    // unique
    var uniq = [];
    for (var u = 0; u < fieldNames.length; u++) {
      if (uniq.indexOf(fieldNames[u]) === -1) uniq.push(fieldNames[u]);
    }
    fieldNames = uniq;

    var fieldsHtml = fieldNames.length
      ? '<ul style="padding-left:16px;margin:6px 0 0 0;">' +
          fieldNames.map(function (f) { return "<li>" + f + "</li>"; }).join("") +
        "</ul>"
      : '<div style="margin-top:6px;">No field names</div>';

    return (
      '<div style="padding:10px; font-size:12px;">' +
        "<div><b>Site:</b> " + (siteCode || "-") + "</div>" +
        "<div><b>Critical Signals:</b> " + count + "</div>" +
        '<div style="margin-top:6px;"><b>Field Names:</b></div>' +
        fieldsHtml +
      "</div>"
    );
  }
},
          noData: {
            text: "No data available"
          }
        };

        // default site (first available)
        this.defaultsite = categories.length > 0 ? categories[0] : "";

      } catch (err) {
        console.log("getdatasignalsummary error:", err);

        // reset state on error
        this.dataSignalSiteSummary = [];
        this.criticalSignalSeries = [];
        this.criticalSignalOptions = {
          noData: { text: "Failed to load data" }
        };
        this.defaultsite = "";
      } finally {
        this.dataSignalLoading = false;
      }
    },
    async getDataSignalGridData(){
      const idtoken = store.getters.getIdToken;
      this.studyId = store.getters.getStudyIs;
      try{
        const url =
          this.baseapi +"/forms/rbqm/getdatasignalsummary?studyId=" +
          encodeURIComponent(this.studyId) + "&level=Site"+"&isActive=true";

        const res = await axios.get(url,this.head );
        const entities = Array.isArray(res.data) ? res.data : [];
        this.dataSignalGridData = entities;
        this.transformedTechniqueData = this.transformDataByTechnique(entities);
      } catch (err) {
        console.log("getdatasignalsummary error:", err);

        this.criticalSignalOptions = {
          noData: { text: "Failed to load data" }
        };
        this.defaultsite = "";
      } finally {
        this.dataSignalLoading = false;
      }
    },
    async getCriticalDataSignalChart() {
      const idtoken = store.getters.getIdToken;
      this.studyId = store.getters.getStudyIs;

      this.dataSignalLoading = true;

      try {
        const url =
          this.baseapi +
          "/forms/rbqm/getdatasignalsummary?studyId=" +
          encodeURIComponent(this.studyId) + "&flagged=true&level=Site";

        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json"
          }
        });

        // API returns array directly
        const entities = Array.isArray(res.data) ? res.data : [];
        this.buildCriticalSignalTrendChart(entities);


      } catch (err) {
        console.log("getdatasignalsummary error:", err);

      }
    },
    buildCriticalSignalTrendChart(entities) {
      const rows = [];

      for (let i = 0; i < entities.length; i++) {
        const it = entities[i];
        if (!it || !it.runDate) continue;

        const ts = new Date(it.runDate).getTime();
        if (!isFinite(ts)) continue;

        let y = 0;
        if (it.criticalSignalsCount !== undefined && it.criticalSignalsCount !== null) {
          const num = Number(it.criticalSignalsCount);
          y = isFinite(num) ? num : 0;
        }

        rows.push({
          ts: ts,
          iso: new Date(ts).toISOString(),
          y: y
        });
      }


      rows.sort(function (a, b) {
        return a.ts - b.ts;
      });

      const categories = [];
      const values = [];

      for (let j = 0; j < rows.length; j++) {
        categories.push(rows[j].iso);
        values.push(rows[j].y);
      }

      this.criticalSignalTrendSeries = [
        {
          name: "Critical Signals",
          data: values
        }
      ];

      this.criticalSignalTrendOptions = {
        chart: {
          type: "line",
          height: 350,
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        stroke: { curve: "smooth", width: 3 },
        markers: { size: 4 },
        xaxis: {
          type: "datetime",
          categories: categories,
          title: { text: "Run Date" },
          labels: { datetimeUTC: false }
        },
        yaxis: {
          min: 0,
          title: { text: "Critical Signals Count" }
        },
        tooltip: {
          x: { format: "dd MMM yyyy HH:mm" },
          y: {
            formatter: function (val) {
              return val + " signals";
            }
          }
        },
        noData: { text: "No trend data" }
      };
    },
    transformDataByTechnique(entities) {
      // Group data by techniqueName
      const techniqueMap = {};

      for (let i = 0; i < entities.length; i++) {
        const site = entities[i];
        if (!site || !site.criticalDataSignal) continue;

        // Iterate through criticalDataSignal array
        for (let j = 0; j < site.criticalDataSignal.length; j++) {
          const signal = site.criticalDataSignal[j];
          const isFlagged = signal.isFlagged === "true" || signal.isFlagged === true;

          if (!signal.flagTypes) continue;

          // Iterate through flagTypes array
          for (let k = 0; k < signal.flagTypes.length; k++) {
            const flagType = signal.flagTypes[k];
            const techniqueName = flagType.techniqueName;

            if (!techniqueName) continue;

            // Initialize technique entry if not exists
            if (!techniqueMap[techniqueName]) {
              techniqueMap[techniqueName] = {
                techniqueName: techniqueName,
                techniqueCode: flagType.techniqueCode,
                siteAffected: 0,
                siteNotAffected: 0
              };
            }

            // Count affected/not affected
            if (isFlagged) {
              techniqueMap[techniqueName].siteAffected++;
            } else {
              techniqueMap[techniqueName].siteNotAffected++;
            }
          }
        }
      }

      // Convert map to array and sort alphabetically by techniqueName
      return Object.values(techniqueMap).sort((a, b) => {
        return a.techniqueName.localeCompare(b.techniqueName);
      });
    },

    riskClass(score) {
      if (score >= 20) return "risk-high text";
      if (score >= 10) return "risk-medium";
      return "risk-low";
    },
    async getSiteSummary(techniqueCode) {
      try {
        var result = await axios.get(`${this.baseUrl}/forms/rbqm/getdatasignalsummary?studyId=${this.studyId}&techniqueCode=${techniqueCode}&flagged=true&level=Site&isActive=true`, this.head);
        console.log("site summary.........", result.data);
        return result.data;
      }
      catch (error) {
        console.error("Error fetching site summary:", error);
      }
    },
    async openSiteSummary() {
      this.showSiteSummary = true;
    },
    async closeModal() {
      this.showSiteSummary = false;
    },
    async openCriticalSites() {
      this.showCriticalSites = true;
    },
    async closeCriticalSites() {
      this.showCriticalSites = false;
    },
    async openCorrelationSites() {
      this.showCorerelationSites = true;
    },
    async closeCorrelationSites() {
      this.showCorerelationSites = false;
    },
    async openRepatetionSites() {
      this.showRepatetionSites = true;
    },  
    async closeRepatetionSites() {
      this.showRepatetionSites = false;
    },

    openSiteAffectedModal(techniqueName) {
      this.selectedTechniqueName = techniqueName;
      this.siteAffectedDetails = this.getSiteAffectedDetails(techniqueName);
      this.showSiteAffectedModal = true;
    },

    closeSiteAffectedModal() {
      this.showSiteAffectedModal = false;
      this.selectedTechniqueName = "";
      this.siteAffectedDetails = [];
    },

    openSiteNotAffectedModal(techniqueName) {
      this.selectedTechniqueName = techniqueName;
      this.siteNotAffectedDetails = this.getSiteNotAffectedDetails(techniqueName);
      this.showSiteNotAffectedModal = true;
    },

    closeSiteNotAffectedModal() {
      this.showSiteNotAffectedModal = false;
      this.selectedTechniqueName = "";
      this.siteNotAffectedDetails = [];
    },

    getSiteAffectedDetails(techniqueName) {
      const details = [];

      // Iterate through raw data to extract affected sites
      for (let i = 0; i < this.dataSignalGridData.length; i++) {
        const site = this.dataSignalGridData[i];
        if (!site || !site.criticalDataSignal) continue;

        // Iterate through criticalDataSignal array
        for (let j = 0; j < site.criticalDataSignal.length; j++) {
          const signal = site.criticalDataSignal[j];
          const isFlagged = signal.isFlagged === "true" || signal.isFlagged === true;

          if (!isFlagged || !signal.flagTypes) continue;

          // Iterate through flagTypes array
          for (let k = 0; k < signal.flagTypes.length; k++) {
            const flagType = signal.flagTypes[k];

            // Only include entries that match the selected technique
            if (flagType.techniqueName === techniqueName) {
              // Join fieldName array into comma-separated string
              const fieldNameStr = Array.isArray(flagType.fieldName)
                ? flagType.fieldName.join(", ")
                : (flagType.fieldName || "");

              details.push({
                siteCode: site.siteCode || "",
                flagType: signal.flagType || "",
                fieldName: fieldNameStr
              });
            }
          }
        }
      }

      return details;
    },

    getSiteNotAffectedDetails(techniqueName) {
      const details = [];

      // Iterate through raw data to extract not affected sites
      for (let i = 0; i < this.dataSignalGridData.length; i++) {
        const site = this.dataSignalGridData[i];
        if (!site || !site.criticalDataSignal) continue;

        // Iterate through criticalDataSignal array
        for (let j = 0; j < site.criticalDataSignal.length; j++) {
          const signal = site.criticalDataSignal[j];
          const isFlagged = signal.isFlagged === "true" || signal.isFlagged === true;

          // Only process non-flagged entries for "Site Not Affected"
          if (isFlagged || !signal.flagTypes) continue;

          // Iterate through flagTypes array
          for (let k = 0; k < signal.flagTypes.length; k++) {
            const flagType = signal.flagTypes[k];

            // Only include entries that match the selected technique
            if (flagType.techniqueName === techniqueName) {
              // Join fieldName array into comma-separated string
              const fieldNameStr = Array.isArray(flagType.fieldName)
                ? flagType.fieldName.join(", ")
                : (flagType.fieldName || "");

              details.push({
                siteCode: site.siteCode || "",
                flagType: signal.flagType || "",
                fieldName: fieldNameStr
              });
            }
          }
        }
      }
      return details;
    }
  }
};